export const npart = [
  {
    "videoId": "bK0nntFF8FA",
    "title": "엔플라잉 (N.Flying) 9th Mini Album [Still] 잔불 (Still) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/bK0nntFF8FA/default.jpg",
    "url": "https://www.youtube.com/watch?v=bK0nntFF8FA",
    "publishedAt": "2026-10-08T13:00:32Z"
  },
  {
    "videoId": "FnLt6wgYrDw",
    "title": "엔플라잉 (N.Flying) 9th Mini Album [Still] 나를 사랑하지 않는 너에게 (Wake Up) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/FnLt6wgYrDw/default.jpg",
    "url": "https://www.youtube.com/watch?v=FnLt6wgYrDw",
    "publishedAt": "2026-10-08T13:01:01Z"
  },
  {
    "videoId": "H962E7M3FcE",
    "title": "엔플라잉 (N.Flying) 9th Mini Album [Still] 홍실 (Hongsil) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/H962E7M3FcE/default.jpg",
    "url": "https://www.youtube.com/watch?v=H962E7M3FcE",
    "publishedAt": "2026-10-08T13:02:25Z"
  },
  {
    "videoId": "QPR3a_b1z2Q",
    "title": "엔플라잉 (N.Flying) 9th Mini Album [Still] 아는 결말 (Our Ending) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/QPR3a_b1z2Q/default.jpg",
    "url": "https://www.youtube.com/watch?v=QPR3a_b1z2Q",
    "publishedAt": "2026-10-08T13:03:30Z"
  },
  {
    "videoId": "5j5wdF5bex0",
    "title": "N.Flying (엔플라잉) Digital Single [환절기 (換節期)] 환절기 (換節期) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/5j5wdF5bex0/default.jpg",
    "url": "https://www.youtube.com/watch?v=5j5wdF5bex0",
    "publishedAt": "2026-06-03T03:00:08Z"
  },
  {
    "videoId": "LC8xWtb1yNg",
    "title": "N.Flying 2nd Album [Everlasting] 뫼비우스 (Moebius) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/LC8xWtb1yNg/default.jpg",
    "url": "https://www.youtube.com/watch?v=LC8xWtb1yNg",
    "publishedAt": "2025-05-29T09:17:04Z"
  },
  {
    "videoId": "68Ew1opc7z0",
    "title": "N.Flying 2nd Album [Everlasting] Run Like This 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/68Ew1opc7z0/default.jpg",
    "url": "https://www.youtube.com/watch?v=68Ew1opc7z0",
    "publishedAt": "2025-05-29T09:17:01Z"
  },
  {
    "videoId": "sCSXm2ITK0Q",
    "title": "N.Flying 2nd Album [Everlasting] Born To Be 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/sCSXm2ITK0Q/default.jpg",
    "url": "https://www.youtube.com/watch?v=sCSXm2ITK0Q",
    "publishedAt": "2025-05-29T09:16:57Z"
  },
  {
    "videoId": "wxoF46S3AU0",
    "title": "N.Flying 2nd Album [Everlasting] Love You Like That 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/wxoF46S3AU0/default.jpg",
    "url": "https://www.youtube.com/watch?v=wxoF46S3AU0",
    "publishedAt": "2025-05-29T09:16:52Z"
  },
  {
    "videoId": "mTl4TeZshIs",
    "title": "N.Flying 2nd Album [Everlasting] 사랑을 마주하고 (Rise Again) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/mTl4TeZshIs/default.jpg",
    "url": "https://www.youtube.com/watch?v=mTl4TeZshIs",
    "publishedAt": "2025-05-29T09:16:47Z"
  },
  {
    "videoId": "WnJV_Z02lHU",
    "title": "N.Flying 2nd Album [Everlasting] 만년설 (Everlasting) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/WnJV_Z02lHU/default.jpg",
    "url": "https://www.youtube.com/watch?v=WnJV_Z02lHU",
    "publishedAt": "2025-05-29T09:16:43Z"
  },
  {
    "videoId": "DpHC2PRsTjQ",
    "title": "N.Flying 8th Mini Album 'Dearest' 폭망 (I Like You) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/DpHC2PRsTjQ/default.jpg",
    "url": "https://www.youtube.com/watch?v=DpHC2PRsTjQ",
    "publishedAt": "2025-05-26T03:34:10Z"
  },
  {
    "videoId": "oO9AaZ8Vjk4",
    "title": "[N.Flying] 우당탕탕 엔퍄트 연구소 컨퍼런스 (ft. 너에게 응원법)",
    "thumbnail": "https://i.ytimg.com/vi/oO9AaZ8Vjk4/default.jpg",
    "url": "https://www.youtube.com/watch?v=oO9AaZ8Vjk4",
    "publishedAt": "2025-05-26T03:35:06Z"
  },
  {
    "videoId": "TZFIuJ3_2Yc",
    "title": "N.Flying 1st Album 'Man on the Moon' Moonshot 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/TZFIuJ3_2Yc/default.jpg",
    "url": "https://www.youtube.com/watch?v=TZFIuJ3_2Yc",
    "publishedAt": "2025-05-26T03:35:12Z"
  },
  {
    "videoId": "3X-M3Nz-ZsY",
    "title": "N.Flying 7TH MINI ALBUM ‘So, 通 (소통)’ 에요 (E-YO) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/3X-M3Nz-ZsY/default.jpg",
    "url": "https://www.youtube.com/watch?v=3X-M3Nz-ZsY",
    "publishedAt": "2025-05-26T03:35:17Z"
  },
  {
    "videoId": "hUii9VeaU8A",
    "title": "N.Flying 7TH MINI ALBUM ‘So, 通 (소통)’ 아무거나 (I’M GONNA) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/hUii9VeaU8A/default.jpg",
    "url": "https://www.youtube.com/watch?v=hUii9VeaU8A",
    "publishedAt": "2025-05-26T03:35:22Z"
  },
  {
    "videoId": "zY-zL7iV4nI",
    "title": "N.Flying 7TH MINI ALBUM ‘So, 通 (소통)’ 아 진짜요.(Oh really.) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/zY-zL7iV4nI/default.jpg",
    "url": "https://www.youtube.com/watch?v=zY-zL7iV4nI",
    "publishedAt": "2025-05-26T03:36:25Z"
  },
  {
    "videoId": "rpMdDuduJ9o",
    "title": "[엔플라잉] 놔 엔퍄트(응원법)",
    "thumbnail": "https://i.ytimg.com/vi/rpMdDuduJ9o/default.jpg",
    "url": "https://www.youtube.com/watch?v=rpMdDuduJ9o",
    "publishedAt": "2025-05-26T03:38:05Z"
  },
  {
    "videoId": "sQH_EpoCreU",
    "title": "[엔플라잉] ANYWAY 엔퍄트(응원법)",
    "thumbnail": "https://i.ytimg.com/vi/sQH_EpoCreU/default.jpg",
    "url": "https://www.youtube.com/watch?v=sQH_EpoCreU",
    "publishedAt": "2025-05-26T03:38:09Z"
  },
  {
    "videoId": "KCjnvbvvnAI",
    "title": "[엔플라잉] Preview 엔퍄트(응원법)",
    "thumbnail": "https://i.ytimg.com/vi/KCjnvbvvnAI/default.jpg",
    "url": "https://www.youtube.com/watch?v=KCjnvbvvnAI",
    "publishedAt": "2025-05-26T03:38:15Z"
  },
  {
    "videoId": "HJTiA72N6Rg",
    "title": "[이승협/엔플라잉] Anyway 엔퍄트 승협이 알려드림 ㅣ 엔피아 파트 많음/안무 있음 주의",
    "thumbnail": "https://i.ytimg.com/vi/HJTiA72N6Rg/default.jpg",
    "url": "https://www.youtube.com/watch?v=HJTiA72N6Rg",
    "publishedAt": "2025-05-26T03:38:23Z"
  },
  {
    "videoId": "wpKDEWs4IkM",
    "title": "N.Flying 6TH MINI ALBUM [야호(夜好)] Sunset 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/wpKDEWs4IkM/default.jpg",
    "url": "https://www.youtube.com/watch?v=wpKDEWs4IkM",
    "publishedAt": "2025-05-26T03:38:27Z"
  },
  {
    "videoId": "czJPkAi_lwg",
    "title": "N.Flying 6TH MINI ALBUM [야호(夜好)] 4242 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/czJPkAi_lwg/default.jpg",
    "url": "https://www.youtube.com/watch?v=czJPkAi_lwg",
    "publishedAt": "2025-05-26T03:38:36Z"
  },
  {
    "videoId": "CQkawXfqntw",
    "title": "N.Flying 6TH MINI ALBUM [야호(夜好)] ㅈㅅ (Pardon?) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/CQkawXfqntw/default.jpg",
    "url": "https://www.youtube.com/watch?v=CQkawXfqntw",
    "publishedAt": "2025-05-26T03:38:40Z"
  },
  {
    "videoId": "55cU0o69bgs",
    "title": "N.Flying 6TH MINI ALBUM [야호(夜好)] 굿밤 (GOOD BAM) 엔퍄트",
    "thumbnail": "https://i.ytimg.com/vi/55cU0o69bgs/default.jpg",
    "url": "https://www.youtube.com/watch?v=55cU0o69bgs",
    "publishedAt": "2025-05-26T03:38:44Z"
  },
  {
    "videoId": "bXIEU5k-QAc",
    "title": "N.Flying - 봄이 부시게 (Spring Memories) 응원법",
    "thumbnail": "https://i.ytimg.com/vi/bXIEU5k-QAc/default.jpg",
    "url": "https://www.youtube.com/watch?v=bXIEU5k-QAc",
    "publishedAt": "2025-05-26T03:39:26Z"
  },
  {
    "videoId": "h3kD4_t1Zgo",
    "title": "[엔플라잉] N.Flying(엔플라잉) _ Rooftop(옥탑방) 응원법 fan chant",
    "thumbnail": "https://i.ytimg.com/vi/h3kD4_t1Zgo/default.jpg",
    "url": "https://www.youtube.com/watch?v=h3kD4_t1Zgo",
    "publishedAt": "2025-05-26T03:42:36Z"
  }
]
